import React, { useState, useRef, useEffect } from 'react';
import './ChatBot.scss';
import { Dropdown } from 'antd';
import { MoreOutlined, CommentOutlined, LoadingOutlined, SendOutlined } from '@ant-design/icons';
import { useChatbotMutation } from "../../utils/apiSlice";

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [chat, { isLoading }] = useChatbotMutation();
  const chatBodyRef = useRef(null);

  // Auto scroll to bottom
  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [messages]);

  // Default quick options (Doctor project)
  const defaultOptions = [
    "Book Appointment",
    "Check Symptoms",
    "View Prescriptions",
    "Lab Reports",
    "Talk to Doctor",
    "Emergency Help"
  ];

  // Dropdown Menu Items
  const items = [
    { label: 'New Chat', key: 'new-chat' },
    { label: 'Settings', key: 'settings' },
    { type: 'divider' },
    { label: 'Help', key: 'help' },
    { label: 'Privacy', key: 'privacy' },
  ];

  // Send Message
  const handleSend = async (text = message) => {
    if (!text?.trim()) return;

    const userMessage = { type: 'user', text };
    setMessages(prev => [...prev, userMessage]);

    setMessage('');

    try {
      const response = await chat({ message: text }).unwrap();

      const botMessage = {
        type: 'bot',
        text: response?.reply || "Doctor assistant response received."
      };

      setMessages(prev => [...prev, botMessage]);

    } catch (error) {
      setMessages(prev => [
        ...prev,
        { type: 'bot', text: "Something went wrong. Please try again." }
      ]);
      console.error(error);
    }
  };

  return (
    <>
      {/* Floating Icon */}
      <div className="chatbot-icon" onClick={() => setIsOpen(!isOpen)}>
        <CommentOutlined />
      </div>

      {/* Chat Popup */}
      {isOpen && (
        <div className="chat-popup">

          {/* Header */}
          <div className="chat-header">

            {/* Close Button */}
              <Dropdown
              menu={{ items }}
              trigger={['click']}
              placement="bottomRight"

            >
              <button className='chat-menu-button'>
                <MoreOutlined />
              </button>
            </Dropdown>

            <span className="chat-title">Doctor Assistant</span>

            {/* Three Dot Menu */}
          
            <button

              onClick={() => setIsOpen(false)}
              className='chat-cross-button'
            >
              ✖
            </button>

          </div>

          {/* Chat Body */}
          <div className="chat-body" ref={chatBodyRef}>

            {/* Show default options only if no messages */}
            {messages.length === 0 && (
              <>
                <p className="welcome-text">
                  👋 Welcome! How can I assist you today?
                </p>

                <div className="quick-options">
                  {defaultOptions.map((option, index) => (
                    <button
                      key={index}
                      className="quick-option-btn"
                      onClick={() => handleSend(option)}
                    >
                      {option}
                    </button>
                  ))}
                </div>
              </>
            )}

            {/* Messages */}
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`chat-message ${msg.type}`}
              >
                {msg.text}
              </div>
            ))}

            {isLoading && (
              <div className="chat-message bot">
                Typing...
              </div>
            )}

          </div>

          {/* Footer */}
          <div className="chat-footer">
            <input
              type="text"
              placeholder="send a message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) =>
                e.key === 'Enter' && handleSend()
              }
            />

            <div
              style={{
                color: "#5156be",
                fontSize: "24px",
                cursor: isLoading ? "not-allowed" : "pointer",
                opacity: isLoading ? 0.6 : 1,
              }}
              onClick={() => {
                if (!isLoading) handleSend();
              }}
            >
              {isLoading ? <LoadingOutlined spin /> : <SendOutlined />}
            </div>
          </div>

        </div>
      )}
    </>
  );
};

export default ChatBot;
